import { API_BASE_URL, apiFetch } from "../api";

const buildAbsoluteUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const base = API_BASE_URL || "";
  if (!base) return path;
  const baseHasApi = base.endsWith("/api");
  const pathHasApi = path.startsWith("/api/");
  if (baseHasApi && pathHasApi) {
    return `${base}${path.replace(/^\/api/, "")}`;
  }
  if (base.endsWith("/") && path.startsWith("/")) {
    return `${base}${path.slice(1)}`;
  }
  if (!base.endsWith("/") && !path.startsWith("/")) {
    return `${base}/${path}`;
  }
  return `${base}${path}`;
};

export const requestPlanDownloadPath = async (planUuid, type, version) => {
  if (!planUuid || !type) return null;
  const query = new URLSearchParams({ type });
  if (Number.isInteger(version) && version > 0) {
    query.set("version", String(version));
  }
  const res = await apiFetch(`/plan/${planUuid}/download-link?${query.toString()}`, {
    planUuid,
    silent: true,
  });
  if (!res.ok) return null;
  const data = await res.json();
  return data?.path || null;
};

export const openPlanDownload = async (path, fallbackFilename = "") => {
  if (typeof window === "undefined") return false;
  const url = buildAbsoluteUrl(path);
  if (!url) return false;
  try {
    const response = await fetch(url);
    if (!response.ok) return false;
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fallbackFilename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
    return true;
  } catch (_) {
    return false;
  }
};

export const fetchPlanFileBlob = async (planUuid, type, version) => {
  const query = Number.isInteger(version) && version > 0 ? `?version=${version}` : "";
  const res = await apiFetch(`/plan/${planUuid}/${type}${query}`, { planUuid });
  if (!res.ok) return null;
  return res.blob();
};
